var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWebshopInactive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 21 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_15395_6233)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.913 0H6.08696C2.73913 0 0 2.7 0 6V23C0 26.3 2.73913 29 6.08696 29H14.913C18.2609 29 21 26.3 21 23V6C21 2.7 18.3623 0 14.913 0ZM18.971 23C18.971 25.2 17.1449 27 14.913 27H6.08696C3.85507 27 2.02899 25.2 2.02899 23V6C2.02899 3.8 3.85507 2 6.08696 2H14.913C17.1449 2 18.971 3.8 18.971 6V23Z",
    fill: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5508 25.4C11.5033 25.4 12.2754 24.6389 12.2754 23.7C12.2754 22.7611 11.5033 22 10.5508 22C9.59832 22 8.82617 22.7611 8.82617 23.7C8.82617 24.6389 9.59832 25.4 10.5508 25.4Z",
    fill: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_15395_6233)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 9.49411L11.9941 12.5L15 15.4971L13.4971 17L10.5 13.9941L7.49411 17L6 15.4971L9.00589 12.5L6 9.49411L7.49411 8L10.5 11.0059L13.4971 8L15 9.49411Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_15395_6233"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 29,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_15395_6233"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 9,
    height: 9,
    fill: "white",
    transform: "translate(6 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebshopInactive);
export default __webpack_public_path__ + "static/media/webshop-inactive.9848b89167357ba4eef9df05b4a6456d.svg";
export { ForwardRef as ReactComponent };